export function getFullName(data, fallback) {
    if (!data) {
        return fallback || '';
    }
    return [data.firstName, data.lastName].filter(Boolean).join(' ');
}
